module.exports = __webpack_public_path__ + "assets/events_war_white.820e4b15.svg";